// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.receipt-map-page {
    height: 100vh;
    width: 100%;
    position: relative;
  }
  
  .loading,
  .error {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
`, "",{"version":3,"sources":["webpack://./src/modules/Courier/Map/ReceiptMap.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;EACpB;;EAEA;;IAEE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;EACd","sourcesContent":[".receipt-map-page {\r\n    height: 100vh;\r\n    width: 100%;\r\n    position: relative;\r\n  }\r\n  \r\n  .loading,\r\n  .error {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100%;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
